export default __webpack_public_path__ + "static/media/star-wars-logo.3bf2a05e.svg";